import { render, staticRenderFns } from "./ExportSettings.vue?vue&type=template&id=47277801&scoped=true"
import script from "./ExportSettings.vue?vue&type=script&lang=js"
export * from "./ExportSettings.vue?vue&type=script&lang=js"
import style0 from "./ExportSettings.vue?vue&type=style&index=0&id=47277801&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47277801",
  null
  
)

export default component.exports